import { useQuery } from '@tanstack/react-query';
import { fetchClusterKeys, type GetClusterKeysRequest, type GetClusterKeysResponse } from '../../lib/api/cluster';

export function useClusterKeysQuery(params: GetClusterKeysRequest, options: { enabled: boolean; staleTime?: number }) {
  return useQuery<GetClusterKeysResponse>({
    queryKey: ['clusterKeys', params],
    queryFn: () => fetchClusterKeys(params),
    enabled: options.enabled,
    refetchOnWindowFocus: false,
    ...(options?.staleTime ? { staleTime: options.staleTime } : {}),
  });
}
